export enum PeriodTypes {
  MONTH = 'month',
  QUARTER = 'quarter'
}
